// extracted by mini-css-extract-plugin
export default {"clearExpireButton":"C52xXsQBaLo7j5QehEvT"};